import yiyouLogo from './label_logo/yiyou.png';
import JsBarcode from 'jsbarcode';

const generateBarcodes = async (expressNumber) => {
  const createBarcode = (text, options) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    try {
      JsBarcode(svg, text, {
        format: 'CODE128',
        xmlDocument: document,
        background: '#FFFFFF',
        lineColor: '#000000',
        ...options,
      });
    } catch (error) {
      console.error('Barcode generation error:', error);
      return '';
    }

    return svg.outerHTML;
  };

  const mainBarcode = createBarcode(expressNumber, {
    width: 2.15,
    height: 38,
    displayValue: true,
    fontSize: 13,
    textMargin: 2,
    margin: 0,
  });

  const sideBarcode = createBarcode(expressNumber, {
    width: 0.9,
    height: 22,
    displayValue: false,
    margin: 0,
  });

  return {
    mainBarcode,
    sideBarcode,
  };
};

const formatDateTime = (dateString) => {
  if (!dateString) return '-';

  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const maskName = (name) => {
  if (!name) return '-';

  const str = String(name);

  if (str.length <= 1) return str;

  return `${str[0]}${'*'.repeat(Math.max(str.length - 1, 1))}`;
};

const maskPhone = (phone) => {
  if (!phone) return '-';

  const str = String(phone);

  if (str.length <= 4) return str;

  return `${str.slice(0, 2)}******${str.slice(-2)}`;
};

const generateLabel = async (item) => {
  try {
    const expressNumber = item.express_number || item.tracking_number || '';

    const { mainBarcode, sideBarcode } = await generateBarcodes(expressNumber);

    if (!mainBarcode || !sideBarcode) {
      console.error('Failed to generate barcode');
      return null;
    }

    const orderDateTime = formatDateTime(item.created_at);

    const destRouteLabel =
      item.dest_route_label ||
      item.route_label ||
      item.destination_code ||
      '-';

    const packageArea =
      item.package_area ||
      item.collect_area ||
      item.jibao_area ||
      item.package_location ||
      '茂名';

    const productName =
      item.product_name ||
      item.goods_name ||
      item.item_name ||
      '国际医药';

    return `
      <style>
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          @page {
            size: 88mm 120mm;
            margin: 0;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            width: 58mm;
          }
        }

        html,
        body {
          margin: 0;
          padding: 0;
        }

        .zto-label {
          width: 88mm;
          min-height: 120mm;
          box-sizing: border-box;
          border: 1px solid #000;
          font-family: "SimSun", "Microsoft YaHei", Arial, sans-serif;
          background: #fff;
          color: #000;
          overflow: visible;
          margin-left: 1mm;
          margin-top: 2mm;
          transform: scale(1.1);
          transform-origin: top left;
        }

        .label-top {
          height: 18mm;
          box-sizing: border-box;
          border-bottom: 1px dashed #000;
          padding: 1.5mm 2mm 0 2mm;
        }

        .brand-row {
          height: 10mm;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .brand-title {
          font-size: 22px;
          font-weight: 900;
          letter-spacing: 1px;
          line-height: 1;
          white-space: nowrap;
        }

        .logo {
          width: 16mm;
          height: auto;
          margin-top: 1mm;
        }

        .date {
          font-size: 12px;
          line-height: 5mm;
          height: 5mm;
          margin-top: 1mm;
        }

        .route {
          height: 7mm;
          line-height: 7mm;
          text-align: center;
          font-size: 13px;
          font-weight: 900;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .main-area {
          display: flex;
          height: 71mm;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .main-left {
          flex: 1;
          min-width: 0;
        }

        .barcode-main-row {
          height: 16mm;
          display: flex;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .barcode-main {
          flex: 1;
          padding: 1.5mm 2mm 0 2mm;
          box-sizing: border-box;
          overflow: hidden;
        }

        .barcode-main svg {
          width: 100%;
          height: 13mm;
          display: block;
        }

        .side-barcode-box {
          width: 13mm;
          border-left: 1px solid #000;
          position: relative;
          overflow: hidden;
          box-sizing: border-box;
          background: #fff;
        }

        .side-barcode-inner {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%) rotate(90deg);
          width: 68mm;
          height: 11mm;
        }

        .side-barcode-inner svg {
          width: 68mm;
          height: 11mm;
          display: block;
        }

        .zto-middle-title {
          height: 8mm;
          line-height: 8mm;
          text-align: center;
          font-size: 13px;
          font-weight: 900;
          letter-spacing: 4px;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .package-row {
          height: 9mm;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .package-label {
          padding-left: 2mm;
          font-size: 13px;
          font-weight: 900;
          white-space: nowrap;
        }

        .package-value {
          padding-left: 2mm;
          font-size: 13px;
          font-weight: 900;
          white-space: nowrap;
        }

        .info-row {
          display: flex;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .receiver-row {
          height: 26mm;
        }

        .sender-row {
          height: 12mm;
          border-bottom: 0;
        }

        .row-label {
          width: 8mm;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17px;
          font-weight: 900;
          border-right: 1px solid #000;
          box-sizing: border-box;
        }

        .row-content {
          flex: 1;
          padding: 2mm 2mm;
          box-sizing: border-box;
          font-size: 13px;
          line-height: 1.35;
          overflow: hidden;
        }

        .name-line {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 1mm;
          white-space: nowrap;
        }

        .address-line {
          font-size: 10px;
          font-weight: 700;
          line-height: 1.35;
          word-break: break-all;
        }

        .product-row {
          height: 12mm;
          padding: 1.5mm 2mm;
          box-sizing: border-box;
          border-bottom: 1px solid #000;
          font-size: 12px;
          overflow: hidden;
        }

        .bottom-row {
          height: 14mm;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          padding: 0 2mm 1.5mm 2mm;
          box-sizing: border-box;
        }

        .order-info {
          font-size: 10px;
          font-weight: 700;
          line-height: 1.5;
          white-space: nowrap;
        }

        .checked-info {
          text-align: right;
          font-size: 15px;
          font-weight: 900;
          line-height: 1.35;
          white-space: nowrap;
        }
      </style>

      <div class="zto-label">
        <div class="label-top">
          <div class="brand-row">
            <div class="brand-title">ZTO 中通国际</div>
            <img class="logo" src="${yiyouLogo}" alt="logo" />
          </div>

          <div class="date">${orderDateTime}</div>
        </div>

        <div class="route">
          ${destRouteLabel}
        </div>

        <div class="main-area">
          <div class="main-left">
            <div class="barcode-main-row">
              <div class="barcode-main">
                ${mainBarcode}
              </div>
            </div>

            <div class="zto-middle-title">
              ZTO 中通国际
            </div>

            <div class="package-row">
              <div class="package-label">集包地:</div>
              <div class="package-value">${packageArea}</div>
            </div>

            <div class="info-row receiver-row">
              <div class="row-label">收</div>

              <div class="row-content">
                <div class="name-line">
                  ${maskName(item.recipient_name)}　${maskPhone(item.recipient_phone)}
                </div>

                <div class="address-line">
                  ${item.recipient_address || '-'}
                </div>
              </div>
            </div>

            <div class="info-row sender-row">
              <div class="row-label">寄</div>

              <div class="row-content">
                <div class="name-line">
                  ${maskName(item.sender_name)}　${maskPhone(item.sender_phone)}
                </div>

                <div class="address-line">
                  ${item.sender_address || '-'}
                </div>
              </div>
            </div>
          </div>

          <div class="side-barcode-box">
            <div class="side-barcode-inner">
              ${sideBarcode}
            </div>
          </div>
        </div>

        <div class="product-row">
          ${productName}
        </div>

        <div class="bottom-row">
          <div class="order-info">
            <div>订单编号：${item.order_number || '-'}</div>
            <div>备注：${item.notes || '-'}</div>
          </div>

          <div class="checked-info">
            <div>一邮・速递</div>
            <div>已验视</div>
          </div>
        </div>
      </div>
    `;
  } catch (error) {
    console.error('Failed to generate label:', error);
    return null;
  }
};

export default generateLabel;